import { LOGIN_USER, REMOVE_TOKEN, REMOVE_USER, SET_NOTIFICATION_FLAG, SET_TOKEN } from "../types"


const loginUser = (user) => {
    return {
        type: LOGIN_USER,
        user
    }
}

const removeUser = () => {
    return {
        type: REMOVE_USER
    }
}

const setNotificationFlag = (value) => ({
    type: SET_NOTIFICATION_FLAG,
    payload: value,
})

const authToken = (token) => ({
    type: SET_TOKEN,
    payload: token,
})

const removeToken = () => {
    return {
        type: REMOVE_TOKEN
    }
}

export {
    loginUser,
    removeUser,
    authToken,
    removeToken,
    setNotificationFlag
}